export default function () {
  return {
    isVisible: false,
    message: '',
    timeoutID: null,
  };
}
